import React, { createContext, useState, useMemo, useContext } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

const PortalContext = createContext();

const PortalProvider = ({ children = null, targetContainer = '#portal-root' }) => {
  const [portal, setPortal] = useState(false);
  const [portalContent, setPortalContent] = useState(null);

  const showPortal = (content = false) => {
    setPortal(true);
    if (content) setPortalContent(content);
  };

  const hidePortal = () => {
    setPortal(false);
    setPortalContent(null);
  };

  const value = useMemo(
    () => ({ portal, portalContent, showPortal, hidePortal }),
    [portal, portalContent]
  );

  return (
    <PortalContext.Provider value={value}>
      {portal && ReactDOM.createPortal(portalContent, document.querySelector(targetContainer))}
      {children}
    </PortalContext.Provider>
  );
};

PortalProvider.propTypes = {
  targetContainer: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf([PropTypes.node]),
    PropTypes.string
  ])
};

const usePortal = () => useContext(PortalContext);

export { PortalContext, PortalProvider, usePortal };
